import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { siteStage } from "./config/siteStage";
import LandingPage from "./pages/LandingPage";
import FeatureBacklogPage from "./pages/FeatureBacklogPage";
import CompliancePage from "./pages/CompliancePage";
import ProvidersPage from "./pages/ProvidersPage";
import EnterpriseProvidersPage from "./pages/EnterpriseProvidersPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogPostPage from "./pages/BlogPostPage";
import AboutPage from "./pages/AboutPage";
import FeesPage from "./pages/FeesPage";
import PrivacyPage from "./pages/PrivacyPage";
import ResidentPilotPage from "./pages/ResidentPilotPage";
import RecoverPilotLinkPage from "./pages/RecoverPilotLinkPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import ResidentsPage from "./pages/ResidentsPage";
import ResidentGroupsPage from "./pages/ResidentGroupsPage";
import UpdatesPage from "./pages/UpdatesPage";
import FaqPage from "./pages/FaqPage";
import StatusPage from "./pages/StatusPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/features" element={<FeatureBacklogPage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/providers" element={<ProvidersPage />} />
          <Route path="/providers/enterprise" element={<EnterpriseProvidersPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/about" element={<AboutPage />} />
          {/* /fees exposes provider pricing — only routable while public pricing is enabled */}
          <Route
            path="/fees"
            element={siteStage.publicPricingEnabled ? <FeesPage /> : <Navigate to="/providers" replace />}
          />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/resident-pilot" element={<ResidentPilotPage />} />
          <Route path="/resident-pilot/recover" element={<RecoverPilotLinkPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/support" element={<Navigate to="/residents#support" replace />} />
          <Route path="/residents" element={<ResidentsPage />} />
          <Route path="/resident-groups" element={<ResidentGroupsPage />} />
          <Route path="/updates" element={<UpdatesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
